export const modalDescription =
  'Some permissions need to be granted before you can refresh the connection on this page.';
